
import { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import AmortizationSchedule from '@/components/investor/AmortizationSchedule';
import { Investment } from '@/types/investment';

export const usePrintAmortization = () => {
  const printAmortizationSchedule = (investment: Investment) => {
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    
    if (!printWindow) {
      alert('Please allow popups to print the amortization schedule');
      return;
    }

    // Set up the print window
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Amortization Schedule - ${investment.propertyAddress || investment.type}</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 0; 
              padding: 0; 
              background: white;
            }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div id="print-content"></div>
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 100);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    
    // Render the AmortizationSchedule component
    const printContent = printWindow.document.getElementById('print-content');
    if (printContent) {
      const root = createRoot(printContent);
      root.render(<AmortizationSchedule investment={investment} />);
    }
  };

  return { printAmortizationSchedule };
};
